/**
 * Legacy-Redirect: /dashboard_boxes → /dashboard/customize
 *
 * v1-URL der Widget-Auswahl (app/views/dashboard_boxes/show.haml). Alte
 * Bookmarks und Links aus dem Monolithen landen damit auf der v2-Seite.
 * Muster wie routes/api-tokens.tsx und routes/reportings.tsx.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard_boxes')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/customize', replace: true })
  },
  component: () => null,
})
